import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import {
  ARTICLE_TEXT_CONTENT_REDUCER_TOKEN,
  articleTextContentReducerProvider,
  rootReducerKey
} from './text-content.reducer';
import { ArticleTextContentEffects } from './text-content.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, ARTICLE_TEXT_CONTENT_REDUCER_TOKEN),
    EffectsModule.forFeature([ArticleTextContentEffects])
  ],
  providers: [
    articleTextContentReducerProvider
  ]
})
export class ArticleTextContentStoreModule {
}
